import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { apiError } from "../api";
import { AuthShell } from "./Login";
import { UserPlus, Loader2 } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ full_name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await register(form);
      toast.success(`Welcome to InfosecGig Academy, ${u.full_name.split(" ")[0]}!`);
      navigate("/app/dashboard");
    } catch (err) {
      toast.error(apiError(err, "Registration failed"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Create your account" subtitle="Start learning in seconds — no verification needed.">
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <div>
          <label className="label">Full name</label>
          <input className="input" value={form.full_name} onChange={set("full_name")} required placeholder="Jane Doe" data-testid="register-name" />
        </div>
        <div>
          <label className="label">Email</label>
          <input className="input" type="email" value={form.email} onChange={set("email")} required placeholder="you@example.com" data-testid="register-email" />
        </div>
        <div>
          <label className="label">Password</label>
          <input className="input" type="password" value={form.password} onChange={set("password")} required placeholder="At least 6 characters" data-testid="register-password" />
        </div>
        <button className="btn-primary w-full !py-3" disabled={busy} data-testid="register-submit">
          {busy ? <Loader2 className="animate-spin" size={18} /> : <UserPlus size={18} />} Create account
        </button>
      </form>
      <p className="text-center text-sm text-slate-400 mt-6">
        Already have an account? <Link to="/login" className="text-[#F26522] font-medium hover:underline" data-testid="to-login">Log in</Link>
      </p>
    </AuthShell>
  );
}
